import withQuestionSearchData from "../../questions/withQuestionSearchData";
import QuestionSearch from "./QuestionSearch";

export default withQuestionSearchData(QuestionSearch);
